var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.288 12.203a1.6 1.6 0 1 0 0-3.203 1.6 1.6 0 0 0 0 3.203zM7.46 14.765a1.548 1.548 0 1 0 0-3.096 1.548 1.548 0 0 0 0 3.095zm-2.883 2.562a1.12 1.12 0 1 0 0-2.242 1.12 1.12 0 0 0 0 2.242zm-2.83 2.456a.747.747 0 1 0 0-1.495.747.747 0 0 0 0 1.495zm2.776 2.882a.747.747 0 1 0 0-1.494.747.747 0 0 0 0 1.496zm12.278-.747a.747.747 0 1 1-1.494 0 .747.747 0 0 1 1.495 0zm.32-5.712a1.12 1.12 0 1 1-2.24 0 1.12 1.12 0 0 1 2.24 0zM7.46 20.21a1.12 1.12 0 1 0 0-2.242 1.12 1.12 0 0 0 0 2.242zm6.778-1.12a1.12 1.12 0 1 1-2.242 0 1.12 1.12 0 0 1 2.242 0zm.32-5.873a1.548 1.548 0 1 1-3.095 0 1.548 1.548 0 0 1 3.096 0zM11.89 16.26a1.6 1.6 0 1 1-3.203 0 1.6 1.6 0 0 1 3.203 0zm9.822-4.057a1.6 1.6 0 1 1 0-3.203 1.6 1.6 0 0 1 0 3.203zm2.829 2.562a1.548 1.548 0 1 1 0-3.096 1.548 1.548 0 0 1 0 3.095zm1.762 1.441a1.12 1.12 0 1 0 2.243 0 1.12 1.12 0 0 0-2.243 0zm3.95 3.577a.747.747 0 1 1 0-1.495.747.747 0 0 1 0 1.495zm-2.775 2.882a.747.747 0 1 1 0-1.494.747.747 0 0 1 0 1.496zM24.54 20.21a1.12 1.12 0 1 1 0-2.242 1.12 1.12 0 0 1 0 2.242zm-6.778-1.12a1.12 1.12 0 1 0 2.242 0 1.12 1.12 0 0 0-2.242 0zm-.32-5.873a1.548 1.548 0 1 0 3.095 0 1.548 1.548 0 0 0-3.096 0zm2.668 3.043a1.6 1.6 0 1 0 3.203 0 1.6 1.6 0 0 0-3.203 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMath);
export default __webpack_public_path__ + "static/media/MATH.21eba5e38d6810166e57438ba65f4494.svg";
export { ForwardRef as ReactComponent };